module.exports = "pegasus/assets/tech/holiday_2/101.png";